import React from "react";
import { statusPill, URGENCY_STYLES } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  if (!status) return null;
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border whitespace-nowrap", statusPill(status), className)}
    >
      {status}
    </span>
  );
}

export function UrgencyBadge({ urgency }) {
  if (!urgency) return null;
  return (
    <span className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border", URGENCY_STYLES[urgency] || URGENCY_STYLES.Routine)}>
      {urgency}
    </span>
  );
}
